import { render } from "./UpgraderItems.vue?vue&type=template&id=3c62b4e6&scoped=true"
import script from "./UpgraderItems.vue?vue&type=script&lang=js"
export * from "./UpgraderItems.vue?vue&type=script&lang=js"

import "./UpgraderItems.vue?vue&type=style&index=0&id=3c62b4e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c62b4e6"]])

export default __exports__